import React, { Suspense, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { House2 as HouseIcon, Calendar2 as CalendarIcon, Location } from '@refera/ui-icons'
import WhatsappIcon from '_assets/icons/ic-whatsapp.svg'

import classNames from 'classnames'

import Svg from '_/components/svg'
import Priority from '_/components/priority'

import useStyles from './styles'
import moment from 'moment'

const WhatsappModal = React.lazy(() =>
  import('../whatsapp-modal').then(mod => ({ default: mod.WhatsappModal }))
)

export function KanbanCard({ serviceOrder, className, viewOnlyMode = false }) {
  const styles = useStyles()
  const {
    id = '',
    propertyCode = '',
    category = '',
    createdAt = '',
    priority = undefined,
    phone = {},
    tenantName = '',
    address = {},
  } = serviceOrder || {}
  const [isWhatsappDialogOpen, setIsWhatsappDialogOpen] = useState(false)

  function handleWhatsappButtonClick(e) {
    e.stopPropagation()
    setIsWhatsappDialogOpen(true)
  }

  function Header() {
    if (!id && !Number.isInteger(priority) && !propertyCode) return null
    return (
      <div className={styles.spacedSection}>
        <div className={styles.itemWithIconWrapper}>
          {id && <span className={classNames(styles.itemText, styles.bold)}>{id}</span>}
          {Number.isInteger(priority) && priority > -1 && priority < 4 && (
            <div className={styles.priorityWrapper}>
              <Priority value={priority} showText={false} />
            </div>
          )}
        </div>
        {propertyCode && (
          <div className={styles.itemWithIconWrapper}>
            <HouseIcon className={styles.icons} />
            <span className={styles.itemText}>{propertyCode}</span>
          </div>
        )}
      </div>
    )
  }

  function Content() {
    if (!tenantName && !category && !address) return null

    const mainAddress = address?.address
      ? `${address.address}${address?.number ? ` ${address.number}` : ''}`
      : ''

    return (
      <Grid className={styles.content}>
        {!!tenantName && (
          <Typography className={classNames(styles.itemText, styles.ellipsisSingleLine)}>
            Inquilino: {tenantName}
          </Typography>
        )}
        {!!category && (
          <Typography className={classNames(styles.categoryText, styles.ellipsisDoubleLine)}>
            {category || 'Sem categoria'}
          </Typography>
        )}
        {!!mainAddress && (
          <div className={classNames(styles.itemWithIconWrapper, styles.addressRow)}>
            <Location className={styles.icons} />
            <div className={styles.addressWrapper}>
              <span className={classNames(styles.itemText, styles.ellipsisSingleLine)}>
                {mainAddress || 'Sem endereço'}
              </span>
              {address?.complement && (
                <span className={classNames(styles.itemText, styles.ellipsisSingleLine)}>
                  {address?.complement || ''}
                </span>
              )}
            </div>
          </div>
        )}
      </Grid>
    )
  }

  function Footer() {
    if (!createdAt && !phone) return null
    return (
      <div className={styles.spacedSection}>
        {createdAt && (
          <div className={styles.itemWithIconWrapper}>
            <CalendarIcon className={styles.icons} />
            <span className={styles.itemText}>{moment(createdAt).format('DD/MM/YYYY')}</span>
          </div>
        )}

        {Object.keys(phone).length > 0 && (
          <button
            type="button"
            title="WhatsApp"
            aria-label="Abrir WhatsApp"
            className={styles.whatsappButton}
            onClick={handleWhatsappButtonClick}
          >
            <Svg
              icon={WhatsappIcon}
              aria-label="Logo do Whatsapp"
              className={styles.whatsappIcon}
            />
          </button>
        )}
      </div>
    )
  }

  return (
    <Grid className={classNames(styles.container, className)}>
      <Header />
      <Content />
      <Footer />
      {isWhatsappDialogOpen && (
        <Suspense>
          <WhatsappModal
            closeModal={() => setIsWhatsappDialogOpen(false)}
            phonesObject={phone}
            viewOnlyMode={viewOnlyMode}
          />
        </Suspense>
      )}
    </Grid>
  )
}
